import { render, staticRenderFns } from "./LessonDetail.vue?vue&type=template&id=1277eb4d&scoped=true"
import script from "./LessonDetail.vue?vue&type=script&lang=js"
export * from "./LessonDetail.vue?vue&type=script&lang=js"
import style0 from "./LessonDetail.vue?vue&type=style&index=0&id=1277eb4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1277eb4d",
  null
  
)

export default component.exports